<template>
  <v-app id="home">
    <NavBar/>
    <NavBarMobile v-if="false"/>
    <v-container fluid>
      <div class="head">
        <v-row>
          <v-col cols="5">
            <div style="position: relative" class="mt-16">
              <h1 class="text-grey">Olá,</h1>
              <h1 class="text-white">Eu sou Augusto</h1>
              <span class="text-grey">Desenvolvedor Front-end - VueJS & React</span>
              <br/>
              <v-btn tile dark class="text-red mt-8" variant="outlined" @click="goToWhattsapp">
                Contate-me
              </v-btn>
            </div>
          </v-col>
          <v-col cols="2">
            <div
                style="
                position: absolute;
                z-index: 9999;
                bottom: 0;
                margin-left: auto;
                margin-right: auto;
                left: 0;
                right: 0;
                text-align: center;
              "
                class="mt-16"
            >
              <v-icon>fas fa-angle-double-down</v-icon>
            </div>
          </v-col>
          <v-col cols="5">
            <div style="position: relative; z-index: 9999" class="mt-16">
              <v-img
                src="https://zjfdkyiamhvqhixutolr.supabase.co/storage/v1/object/public/produto/minha_foto?t=2022-10-14T12%3A05%3A35.357Z"
                contain
                max-height="300"
              ></v-img>
            </div>
          </v-col>

        </v-row>
      </div>
      <SobreMe/>
      <v-row>
        <SkillsAll/>
      </v-row>
      <ProjetosComp/>


      <v-col cols="12" sm="12" class="px-16" id="contact">
        <v-row>
          <v-col cols="12" sm="4">
            <div class="child">
              <h1>Contact info.</h1>
              <v-btn
                  icon="fas fa-map-marker-alt"
                  color=""
                  class="mt-10"
                  variant="outlined"
              ></v-btn
              >
              <br/>
              <span class="text-caption">Açailandia - MA </span><br/>
              <v-btn
                  icon="fas fa-phone-alt"
                  color=""
                  class="mt-10"
                  variant="outlined"
              ></v-btn
              >
              <br/>
              <span class="text-caption">(99) 99224-2759 </span> <br/>
              <span class="text-caption">(99) 99135-7424</span> <br/>
              <v-btn
                  icon="fas fa-envelope"
                  color=""
                  class="mt-10"
                  variant="outlined"
              ></v-btn
              >
              <br/>
              <span class="text-caption">augusto.frontend@gmail.com </span>
              <br/>
              <span class="text-caption">gutim160@gmail.com </span> <br/>
            </div>
          </v-col>
          <ContateMe/>
        </v-row>
      </v-col>
    </v-container>
    <FooterView/>
  </v-app>
</template>

<script setup>
import NavBar from "../components/NavBar.vue";
import NavBarMobile from "../components/NavBarMobile.vue";
import FooterView from "../components/FooterView.vue";
import ContateMe from "../components/ContateMe.vue";
import ProjetosComp from "@/components/ProjetosComp.vue";
import SobreMe from "@/components/SobreMe.vue";
import SkillsAll from "@/components/skills/SkillsAll.vue";

const goToWhattsapp = () => {
  window.open("https://wa.me/5599992242759?text=Ola+tudo+bom%2C+vi+seu+portf%C3%B3lio+gostaria+de+contratar+seus+servi%C3%A7os", "_blank");
};

</script>

<style scoped>
.v-container {
  padding: 16px 0 16px 0;
}

.head {
  position: relative;
  text-align: center;
  padding: 12px;
  margin-bottom: 6px;
  height: 400px;
  width: 100%;
  color: white;
}

.head:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 50%;
  background: black;
  transform: skew(0deg, 6deg);
}

.head:after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 50%;
  background: black;
  transform: skew(0deg, -6deg);
}

.egg {
  display: block;
  margin-left: 100px;
  margin-top: 50px;
  width: 356px;
  height: 300px;
  background-color: #fbdf7e;
  border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
}

.first {
  width: 100%;
  height: 280px;
  text-align: center;
  padding: 2rem 2rem;
}

.child {
  display: inline-block;
  padding: 2rem 1rem;
  vertical-align: middle;
  text-align: center;
  margin-right: 8px;
}


.pre {
  width: 100%;
  height: 380px;
  text-align: center;
  padding: 0 200px;
  background-color: #f5f5f5;
}

.hire {
  width: 100%;
  height: 200px;
  padding: 0 200px;
  background-color: #e9e9e9;
  margin-top: -24px;
}
</style>
